var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-between"},[_c('span',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('ProductPrice',{attrs:{"price":_vm.amount,"show-decimals":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }